/**
 * Term End Adjust — campus-wide term rollover (termRolloverFn, 2026-09-29).
 */
const API_BASE_URL = 'https://jrgfnay5w2.execute-api.ap-southeast-2.amazonaws.com/v1';

const getAuthToken = () => {
  const oidcStorage = sessionStorage.getItem('oidc.user:https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_3n9j6gDzL:2c6na652k2lkcsaa1ol8m5chp4');
  if (!oidcStorage) return null;
  try {
    const oidcData = JSON.parse(oidcStorage);
    return oidcData.id_token || oidcData.access_token;
  } catch (e) {
    console.error('Error parsing OIDC storage:', e);
    return null;
  }
};

const termRolloverRequest = async (operation, data) => {
  const token = getAuthToken();
  if (!token) throw new Error('Not authenticated. Please log in again.');
  const response = await fetch(`${API_BASE_URL}/term-rollover`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ operation, data })
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || `Request failed with status ${response.status}`);
  return result;
};

/** What a rollover would do to every course group of a campus. Changes nothing. */
export const previewTermRollover = (args) => termRolloverRequest('preview', args);

/** Roll one course group over. Safe to call again after a failure. */
export const applyTermRolloverGroup = (args) => termRolloverRequest('applyGroup', args);
